import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import PurchaseModuleModal from "../modals/PurchaseModuleModal";
import { validateUserRoleIds } from "../GlobalTools";

const canShowPremiumDropdown = validateUserRoleIds([1, 2]);

const ButtonPremium = (props) => {
  // Destructure props
  const {
    serviceName,
    fromView,
    show = canShowPremiumDropdown,
    children = null,
    ...buttonProps
  } = props;
  // Hooks
  const [showPremiumModal, setShowPremiumModal] = useState(false);

  const handleClick = useCallback(() => {
    setShowPremiumModal(true);
  }, []);

  return show ? (
    <>
      <Button {...buttonProps} onClick={handleClick}>
        {children}
        <i className="ms-2 fas fa-crown premiumColor" />
      </Button>
      {showPremiumModal && (
        <PurchaseModuleModal
          showModal={showPremiumModal}
          closeModal={() => setShowPremiumModal(false)}
          name={serviceName}
          originView={fromView}
        />
      )}
    </>
  ) : null;
};

ButtonPremium.propTypes = {
  serviceName: PropTypes.string.isRequired,
  fromView: PropTypes.string.isRequired,
  children: PropTypes.node,
  show: PropTypes.bool,
};

export default ButtonPremium;
